import * as signalR from "@microsoft/signalr";
import { USERINFO } from "../data/constants";
import { getValidAccessToken } from "../utils/accessTokenHelper";
import { attachSignalRLifecycleHandlers, logSignalRTrace } from "../utils/signalRLogger";

let portalConnection: signalR.HubConnection | null = null;
let startPromise: Promise<void> | null = null;

export const getPortalNotificationConnection = (sessionValue?: string) => {
  const effectiveSessionValue =
    sessionValue ?? localStorage.getItem(USERINFO.SESSIONVALUE);

  if (!effectiveSessionValue) {
    throw new Error("No sessionValue available to start SignalR connection");
  }

  if (portalConnection) {
    return portalConnection;
  }

  portalConnection = new signalR.HubConnectionBuilder()
    .withUrl(
      `${process.env.REACT_APP_API_URL}/hubs/portalnotification/?sessionValue=${effectiveSessionValue}`,
      {
        accessTokenFactory: async () => await getValidAccessToken(),
      }
    )
    .withAutomaticReconnect()
    .configureLogging({
      log: (level, message) => {
        if (level >= signalR.LogLevel.Trace) {
          logSignalRTrace(message, portalConnection ?? undefined);
        }
      },
    })
    .build();
  attachSignalRLifecycleHandlers(portalConnection);
  return portalConnection;
};

export const ensurePortalConnectionStarted = async () => {
  if (!portalConnection) {
    throw new Error("Portal connection not created");
  }

  if (portalConnection.state === signalR.HubConnectionState.Connected) {
    return;
  }

  if (startPromise) {
    return startPromise; // reuse ongoing start
  }

  startPromise = portalConnection
    .start()
    .catch(err => {
      console.error("[SignalR] Failed to start:", err);
      throw err;
    })
    .finally(() => {
      startPromise = null;
    });

  return startPromise;
};

export const resetPortalNotificationConnection = () => {
  portalConnection = null;
  startPromise = null;
};


export const createZipProgressConnection = () => {
  const conn = new signalR.HubConnectionBuilder()
    .withUrl(`${process.env.REACT_APP_API_URL}/hubs/portalzip-progress`, {
      accessTokenFactory: async () => await getValidAccessToken()
    })
    .withAutomaticReconnect()
    .configureLogging({
      log: (level, message) => {
        if (level >= signalR.LogLevel.Trace) {
          logSignalRTrace(message, conn);
        }
      },
    })
    .build();
  attachSignalRLifecycleHandlers(conn);
  return conn;
};